import { createAction, props } from '@ngrx/store';
import { GetActuaryReportRequest, GetActuaryReportInformationResponse } from '@ptg-member/types/models/actuary-report.model';

export const setExportActuaryReportStateAction = createAction(
    '[SetExportActuaryReportState/SET] Processing',
);

export const setExportActuaryReportStateSuccessAction = createAction(
    '[SetExportActuaryReportState/SET] Success',
);

export const setExportActuaryReportStateFailureAction = createAction(
    '[SetExportActuaryReportState/SET] Failure',
);

export const clearSetExportActuaryReportStateAction = createAction(
    '[SetExportActuaryReportState/SET] Clear'
);

export const getActuayReportAction = createAction(
    '[GetActuaryReport/API] Send Request',
    props<{ request: GetActuaryReportRequest }>(),
);

export const getActuayReportActionSuccessAction = createAction(
    '[GetActuaryReportList/API] Success',
    props<{ response: GetActuaryReportInformationResponse }>(),
);

export const getActuayReportActionFailAction = createAction(
    '[GetActuaryReportList/API] Fail',
    props<{  error?: any }>()
);

export const clearActuayReportStateAction = createAction(
    '[GetActuaryReportList] Clear',
  );